<template>
  <div role="group" class="input-group">
    <input
      :id="id"
      ref="field"
      @focus.once="clearValue"
      :disabled="disabled"
      :type="fieldType"
      :value="value"
      @keydown="doKeyDown"
      @input="sendChanges"
      autocomplete="false"
      :placeholder="placeholder"
      class="form-control"
      :readonly="readonly"
      :maxlength="maxlength?maxlength:null"
      :class="{ 'is-valid': state === true, 'is-invalid': state === false, [fieldType]: true }"
    />
    <div class="input-group-append" v-if="generator">
      <div class="input-group-text" @click="generatePassword">
        <font-awesome-icon icon="magic" size="xs" />
      </div>
    </div>
    <div class="input-group-append" v-if="allowstatechange">
      <div class="input-group-text" @click="changeType">
        <font-awesome-icon :icon="fieldType == 'password' ? 'eye' : 'eye-slash'" size="xs" />
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'passwordField',
  components: { FontAwesomeIcon },
  props: {
    id: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    allowstatechange: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean
    },
    readonly: {
      type: Boolean
    },
    maxlength: {
      type: [ Number, String ]
    },
    generator: {
      type: Boolean
    }
  },
  data: function() {
    return {
      fieldType: 'password'
    };
  },
  created() {},
  destroyed() {},
  methods: {
    sendChanges(e) {
      this.$emit('input', e.target.value);
    },
    clearValue() {
      if ((this.fieldType === 'password') && (this.value !== '')) {
        this.value = '';
        this.$emit('input', '');
      }
    },
    generatePassword() {
      if (!this.disabled) {
        this.$emit('generate');
        this.showPassword();
      }
    },
    changeType() {
      if (!this.disabled) {
        if (this.fieldType === 'password') {
          this.showPassword();
        } else {
          this.hidePassword();
        }
      }
    },
    showPassword() {
      if (this.fieldType !== 'text') {
        this.$emit('changetype', 'text');
        this.fieldType = 'text';
      }
    },
    hidePassword() {
      if (this.fieldType !== 'password') {
        this.$emit('changetype', 'password');
        this.fieldType = 'password';
      }
    },
    doKeyDown(e) {
      if (e.key) {
        const ch = e.key.charCodeAt(0);
        if ((ch < 33) || (ch > 126)) {
          e.preventDefault();
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.input-group-text {
  padding: 0 0.3em;
}
  input.password {
    // -webkit-text-security: disc;
  }
</style>
